import { Button, makeStyles } from '@material-ui/core'

import React from 'react'

import AccordionTwoHead from 'asterX-UI/Accordion/AccordionTwoHead'
import FieldInfoNG from 'asterX-UI/DataDisplay/FieldInfoNG'
import { ERROR_COLORS, GRAY_COLORS, PRIMARY_COLORS } from 'asterX-UI'

import PhoneView from 'components/PhoneView'
import TimerDiffDate from 'components/TimerDiffDate'
import CarCard from 'components/Mobile/Car/CarCard'
import CreditApprovalModal from 'components/Mobile/CreditApprovalModal'
import ChipStandard from '../../../asterX-UI/DataDisplay/ChipStandard'

const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    width: '100%'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 8
  }
}))
const style = {
  color: GRAY_COLORS[700],
  fontSize: 14,
  fontWeight: 400
}

const ClientView = ({ sale }) => {
  const classes = useStyles()
  const getActiveChip = isActive =>
    isActive
      ? {
          color: PRIMARY_COLORS[700],
          backgroundColor: PRIMARY_COLORS[100]
        }
      : {
          color: ERROR_COLORS[700],
          backgroundColor: ERROR_COLORS[100]
        }

  return (
    <AccordionTwoHead
      heading={`${sale?.client?.firstName || ''} ${
        sale?.client?.lastName || ''
      }`}
    >
      <div className={classes.container}>
        <div className={classes.row}>
          <PhoneView phone={sale?.client?.phoneNumber} />
        </div>
        <div className={classes.row}>
          <FieldInfoNG
            label={'Онлайн кредит'}
            isVertical
            rootStyle={{
              width: '49%'
            }}
          >
            <CreditApprovalModal phone={sale?.client?.phoneNumber} />
          </FieldInfoNG>
          <FieldInfoNG
            label={'Долг сделки'}
            isVertical
            rootStyle={{
              width: '49%'
            }}
            style={{
              color: ERROR_COLORS[600],
              fontSize: 14,
              fontWeight: 400
            }}
          >
            -
          </FieldInfoNG>
          {/*       <FieldInfoNG
            label={'Офлайн кредит'}
            isVertical
            rootStyle={{
              width: '50%'
            }}
          >
            <ChipStandard
              color={SUCCESS_COLORS[700]}
              backgroundColor={SUCCESS_COLORS[50]}
            >
              Одобрено
            </ChipStandard>
          </FieldInfoNG>*/}
        </div>

        <div className={classes.row}>
          <FieldInfoNG
            label={'Время РЛ'}
            isVertical
            rootStyle={{
              width: '50%'
            }}
          >
            <TimerDiffDate date={sale?.createdDate} />
          </FieldInfoNG>
          <FieldInfoNG
            label={'Менеджер'}
            isVertical
            rootStyle={{
              width: '50%'
            }}
          >
            {sale?.assignToFullName || '-'}
          </FieldInfoNG>
        </div>
        <div className={classes.row}>
          <FieldInfoNG
            label={'Операции'}
            isVertical
            labelStyle={{ minWidth: 100 }}
            style={{ display: 'flex', alignItems: 'center', gap: 10 }}
          >
            <ChipStandard {...getActiveChip(sale?.carst)}>Подвод</ChipStandard>
            <ChipStandard {...getActiveChip(sale?.isRedirect)}>
              Трейд ин
            </ChipStandard>
            <ChipStandard {...getActiveChip(sale?.creditRequests)}>
              Новый контракт
            </ChipStandard>
          </FieldInfoNG>
        </div>
        <div className={classes.row}>
          <FieldInfoNG label={'Филиал'} isVertical style={style}>
            {sale?.branch?.name || 'Филиал не указан'}
          </FieldInfoNG>
        </div>

        {sale?.car?.id && (
          <div>
            <CarCard car={sale?.car} />
          </div>
        )}

        <div className={classes.row}>
          <Button variant={'contained'} fullWidth>
            Редактировать данные клиента
          </Button>
        </div>
      </div>
    </AccordionTwoHead>
  )
}

export default ClientView
